
export const GET_AUTH_SIGNUP_LOADING ="GET_AUTH_SIGNUP_LOADING"
export const GET_AUTH_SIGNUP_SUCESS ="GET_AUTH_SIGNUP_SUCESS"
export const GET_AUTH_SIGNUP_FAILURE ="GET_AUTH_SIGNUP_FAILURE"
export const GET_AUTH_LOGIN_LOADING ="GET_AUTH_LOGIN_LOADING"
export const GET_AUTH_LOGIN_SUCESS ="GET_AUTH_LOGINP_SUCESS"
export const GET_AUTH_LOGIN_FAILURE ="GET_AUTH_LOGIN_FAILURE"
export const GET_AUTH_LOGOUT_LOADING ="GET_AUTH_LOGOUT_LOADING"
export const GET_AUTH_LOGOUT_SUCESS ="GET_AUTH_LOGOUT_SUCESS"
export const GET_AUTH_LOGOUT_FAILURE ="GET_AUTH_LOGOUT_FAILURE"
export const GET_AUTH_VERIFY_LOADING ="GET_AUTH_VERIFY_LOADING"
export const GET_AUTH_VERIFY_SUCESS ="GET_AUTH_VERIFY_SUCESS"
export const GET_AUTH_VERIFY_FAILURE ="GET_AUTH_VERIFY_FAILURE"